import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FileProvider } from '../file.provider';
import { StoredFile } from '../../model/file';

@Component({
    selector: 'file-tree',
    templateUrl: './file.tree.html',
    styleUrls: ['./file.tree.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [FileProvider]
})
export class FileTree implements OnChanges {

    @Output('select')
    onSelect: EventEmitter<StoredFile> = new EventEmitter();

    @Input()
    folders: StoredFile[] = [];

    @Input()
    resource: string = 'Sameh';

    root: string = '';      //'D://';
    path: string = '';

    @Input()
    selected_id: number;

    @Input()
    disabled: boolean;

    @Input()
    disabled_id: number;

    constructor(private fileProvider: FileProvider) {
    }

    ngOnInit() {
        this.reload();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.path || changes.resource) {
            this.reload();
        }
    }

    reload() {
        // let p =this.root + this.path;
        // if (!p.length) return;
        if (!this.resource || !this.resource.length) return;

        //console.log("calling tree", this.path + this.resource);

        // this.fileProvider.exploreFiles(this.root + this.path, this.resource)
        // this.fileProvider.getFolders(this.selected_id, this.resource)
        this.fileProvider.getFolders(null, this.resource)
        .then(data => {
            this.folders = [];
            for(let f of data) {
                if (f.isDirectory()) {
                    this.folders.push(f);
                }
            }
        });
    }

    select(file: StoredFile) {
        this.selected_id = file.id;
        //console.log("Tree: ", event);
        this.onSelect.emit(file);
    }

    // childSelected(event: File) {
    //     console.log("Tree: ", event);
    //     this.onSelect.emit(event);
    // }
}